import { memo } from "react";
import Risk from './Risk'
import AccountLeverage from "./AccountLeverage";
import { AccountImpactWrap } from "./style";

const AccountImpact = memo(() => {
    return <AccountImpactWrap>
        <Risk />
        <AccountLeverage />
    </AccountImpactWrap>
})

export default AccountImpact